import { render, staticRenderFns } from "./oneToOneClass.vue?vue&type=template&id=791e6716&scoped=true"
import script from "./oneToOneClass.vue?vue&type=script&lang=js"
export * from "./oneToOneClass.vue?vue&type=script&lang=js"
import style0 from "./oneToOneClass.vue?vue&type=style&index=0&id=791e6716&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791e6716",
  null
  
)

export default component.exports